import React, { FC, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import padStart from 'lodash/padStart'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Spinner } from 'transfix-ui/components/Spinner'
import { callApi, ENDPOINTS } from 'utils/api/callApi'

const LineNumber = (props: { num: number }) => {
  const { num } = props
  // TODO: add a separator between line nums & text
  return <span className='tr pa4'>{padStart((num + 1).toString(), 3)}.</span>
}

const Segment = (props: { text: string; separator: string }) => {
  const { separator, text } = props
  const segmentValues = text.split(separator)
  const segmentName = segmentValues.shift()
  return (
    <span>
      <span className='body-bold'>{segmentName}</span>
      {segmentValues.map((segmentValue, i) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <span key={i}>
            <span className='pa1'>{separator}</span>
            <span>{segmentValue}</span>
          </span>
        )
      })}
    </span>
  )
}

const EdiContent = (props: { text: string }) => {
  const { text } = props

  // TODO: determine what the segment separator is - assuming ~
  // TODO: better error handling for value separator match instead of assuming *
  const valueSeparatorMatch = text.match('ISA(.)')
  const valueSeparator = valueSeparatorMatch ? valueSeparatorMatch[1] : '*'
  const segmentSeparator = '~'

  let ediLines = text.trim().split('\n')
  if (ediLines.length === 1) {
    ediLines = text
      .split(segmentSeparator)
      .slice(0, -1)
      .map(line => `${line}${segmentSeparator}`)
  }

  return (
    <div>
      <pre>
        {ediLines.map((ediLine, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={i}>
            <LineNumber num={i} />
            <Segment text={ediLine} separator={valueSeparator} />
          </div>
        ))}
      </pre>
    </div>
  )
}

export const EdiFileDetails: FC = () => {
  const { id: ediFileId } = useParams<{ id: string }>()

  const [ediContent, setEdiContent] = useState<string>()
  const [loading, setLoading] = useState(false)
  const [loadingError, setLoadingError] = useState(false)

  const fetchDataFromApi = async () => {
    setLoading(true)
    setLoadingError(false)

    try {
      const res: any = await callApi({
        endpoint: ENDPOINTS.ediFiles,
        id: ediFileId,
        method: 'GET',
      })
      setLoading(false)
      setEdiContent(res.ediContent)
    } catch (e) {
      setLoading(false)
      setLoadingError(true)
    }
  }

  useEffect(() => {
    fetchDataFromApi()
  }, [])

  return (
    <div className='flex justify-center'>
      {!loading && !ediContent && (
        <InlineMessage
          message='There is no EDI file content available at that ID'
          type={INLINE_MESSAGE_VARIANTS.INFO}
        />
      )}
      {!loading && loadingError && (
        <InlineMessage
          message='There was an error loading the EDI file content.'
          type={INLINE_MESSAGE_VARIANTS.ALERT}
        />
      )}
      {loading && <Spinner position='relative' />}
      {!loading && ediContent ? <EdiContent text={ediContent} /> : ''}
    </div>
  )
}
